import {ClientEvent} from '@udemy/event-tracking';
import {TrackingContext} from '@udemy/event-tracking/dist/@types/tracker/tracker';

export class PayslipDownloadedEvent extends ClientEvent {
    constructor() {
        super('PayoutsReportPayslipDownloaded');
    }
    processContext(context: TrackingContext): void {
        super.processContext(context);
    }
}
